import TaskListWrapper from "../TaskListWrapper";

export default function OngoingList({ list, setList }) {
  return <TaskListWrapper setList={setList} data={list} />;
}
